module.exports = [
  {id: 'ATG', iddZone: 'A', travelZone: '1'},
  {id: 'ABW', iddZone: 'A', travelZone: '1'},
  {id: 'AIA', iddZone: 'A', travelZone: '1'},
  {id: 'BRB', iddZone: 'A', travelZone: '1'},
  {id: 'BMU', iddZone: 'A', travelZone: '1'},
  {id: 'BES', iddZone: 'A', travelZone: '1'},
  {id: 'CUW', iddZone: 'A', travelZone: '1'},
  {id: 'DMA', iddZone: 'A', travelZone: '1'},
  {id: 'SLV', iddZone: 'A', travelZone: '1'},
  {id: 'GRD', iddZone: 'A', travelZone: '1'},
  {id: 'GUY', iddZone: 'A', travelZone: '1'},
  {id: 'CYM', iddZone: 'A', travelZone: '1'},
  {id: 'VGB', iddZone: 'A', travelZone: '1'},
  {id: 'JAM', iddZone: 'A', travelZone: '1'},
  {id: 'MSR', iddZone: 'A', travelZone: '1'},
  {id: 'KNA', iddZone: 'A', travelZone: '1'},
  {id: 'LCA', iddZone: 'A', travelZone: '1'},
  {id: 'VCT', iddZone: 'A', travelZone: '1'},
  {id: 'TTO', iddZone: 'A', travelZone: '1'},
  {id: 'TCA', iddZone: 'A', travelZone: '1'},
  {id: 'USA', iddZone: 'A', travelZone: '2'},
  {id: 'CAN', iddZone: 'A', travelZone: '2'},
  {id: 'PRI', iddZone: 'A', travelZone: '2'},
  {id: 'SUR', iddZone: 'B', travelZone: '2'},
  {id: 'HTI', iddZone: 'B', travelZone: '2'},
  {id: 'BRA', iddZone: 'B', travelZone: '2'},
  {id: 'DOM', iddZone: 'B', travelZone: '2'},
  {id: 'SXM', iddZone: 'B', travelZone: '2'},
  {id: 'CHN', iddZone: 'B'},
  {id: 'GBR', iddZone: 'C', travelZone: '2'},
  {id: 'PAN', iddZone: 'C', travelZone: '2'},
  {id: 'ZAF', iddZone: 'C', travelZone: '2'},
  {id: 'DZA', iddZone: 'C'},
  {id: 'SAU', iddZone: 'C'},
  {id: 'ARG', iddZone: 'C'},
  {id: 'ARM', iddZone: 'C'},
  {id: 'AUS', iddZone: 'C'},
  {id: 'BHS', iddZone: 'C', travelZone: '2'},
  {id: 'BLZ', iddZone: 'C', travelZone: '2'},
  {id: 'BLR', iddZone: 'C'},
  {id: 'BIH', iddZone: 'C'},
  {id: 'KHM', iddZone: 'C'},
  {id: 'CHL', iddZone: 'C'},
  {id: 'COL', iddZone: 'C'},
  {id: 'CRI', iddZone: 'C', travelZone: '2'},
  {id: 'CIV', iddZone: 'C'},
  {id: 'KOR', iddZone: 'C'},
  {id: 'CUB', iddZone: 'C', travelZone: '2'},
  {id: 'EGY', iddZone: 'C'},
  {id: 'ARE', iddZone: 'C'},
  {id: 'ECU', iddZone: 'C'},
  {id: 'FJI', iddZone: 'C', travelZone: '2'},
  {id: 'GAB', iddZone: 'C'},
  {id: 'GMB', iddZone: 'C'},
  {id: 'GHA', iddZone: 'C', travelZone: '2'},
  {id: 'GTM', iddZone: 'C'},
  {id: 'GGY', iddZone: 'C', travelZone: '2'},
  {id: 'HND', iddZone: 'C', travelZone: '2'},
  {id: 'HKG', iddZone: 'C'},
  {id: 'IMN', iddZone: 'C'},
  {id: 'FRO', iddZone: 'C'},
  {id: 'IND', iddZone: 'C'},
  {id: 'IDN', iddZone: 'C'},
  {id: 'ISR', iddZone: 'C'},
  {id: 'JPN', iddZone: 'C'},
  {id: 'JEY', iddZone: 'C', travelZone: '2'},
  {id: 'KAZ', iddZone: 'C'},
  {id: 'LBN', iddZone: 'C'},
  {id: 'MKD', iddZone: 'C'},
  {id: 'MDG', iddZone: 'C'},
  {id: 'MUS', iddZone: 'C'},
  {id: 'MAR', iddZone: 'C', travelZone: '2'},
  {id: 'MCO', iddZone: 'C', travelZone: '2'},
  {id: 'MEX', iddZone: 'C'},
  {id: 'NRU', iddZone: 'C', travelZone: '2'},
  {id: 'NIC', iddZone: 'C', travelZone: '2'},
  {id: 'NCL', iddZone: 'C'},
  {id: 'NZL', iddZone: 'C'},
  {id: 'NGA', iddZone: 'C', travelZone: '2'},
  {id: 'OMN', iddZone: 'C'},
  {id: 'UZB', iddZone: 'C'},
  {id: 'PAK', iddZone: 'C'},
  {id: 'PNG', iddZone: 'C', travelZone: '2'},
  {id: 'PRY', iddZone: 'C', travelZone: '2'},
  {id: 'PER', iddZone: 'C'},
  {id: 'PHL', iddZone: 'C'},
  {id: 'PYF', iddZone: 'C'},
  {id: 'QAT', iddZone: 'C'},
  {id: 'RUS', iddZone: 'C'},
  {id: 'WSM', iddZone: 'C', travelZone: '2'},
  {id: 'SYC', iddZone: 'C'},
  {id: 'SLE', iddZone: 'C', travelZone: '2'},
  {id: 'CHE', iddZone: 'C'},
  {id: 'TWN', iddZone: 'C', travelZone: '2'},
  {id: 'THA', iddZone: 'C', travelZone: '2'},
  {id: 'TON', iddZone: 'C', travelZone: '2'},
  {id: 'TUR', iddZone: 'C', travelZone: '2'},
  {id: 'URY', iddZone: 'C'},
  {id: 'UKR', iddZone: 'C'},
  {id: 'VUT', iddZone: 'C', travelZone: '2'},
  {id: 'VEN', iddZone: 'C'},
  {id: 'VNM', iddZone: 'C'},
];
